
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import { RestrictPlanService } from '../../components/restrict-plan.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  redirectUrl;

  constructor(
    private authService: AuthService,
    private router: Router,
    private restrictPlanService: RestrictPlanService
  ) { }

  // Function to check if user is authorized to view route
  canActivate(
    router: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let authStatus = this.authService.loggedIn(state.url)
    // console.log('authStatus-----', authStatus);

    // Check if user is logge din
    if (authStatus === "true") {
      // console.log("in authguard --------true---------");
      // Lead-only plan: anything outside its allowed pages goes to the Lead Dashboard.
      if (this.restrictPlanService.isUrlBlockedForLeadOnly(state.url)) {
        this.router.navigate([RestrictPlanService.LEAD_ONLY_HOME]);
        return false;
      }
      return true; // Return true: User is allowed to view route
    } else if (authStatus === "Resticted") {
      // console.log("in authguard --------Resticted---------");

      this.redirectUrl = state.url; // Grab previous urul
      // this.router.navigate(['/gym/members']); // Return error and route to login page
      this.router.navigate(['/services-restriction']); // Return error and route to services restriction page
    } else {
      // console.log("in authguard --------unauthorised---------");
      this.redirectUrl = state.url; // Grab previous urul
      this.router.navigate(['/login']); // Return error and route to login page
      return false; // Return false: user not authorized to view page
    }
  }

  // Runs on every navigation between child routes (canActivate on the parent only runs when
  // the parent itself activates). Only enforces the lead-only plan, so existing behaviour for
  // every other user is unchanged.
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (this.restrictPlanService.isUrlBlockedForLeadOnly(state.url)) {
      return this.router.createUrlTree([RestrictPlanService.LEAD_ONLY_HOME]);
    }
    return true;
  }
}
